import React from "react"
import { connect } from "react-redux"
import { State, MainThunkDispatch } from "../../../../../../../Reducers"
import {
    deleteAPIKey,
    createAPIKey,
    getAPIKeys
} from "../../../../../../../Actions/API/AuthenticationActions"
import { Title, ModalPanel, AddButton } from "dash-styled"
import { getApiKeys as selectApiKeys } from "../../../../../../../Helpers/Functions/Selectors/auth"
import { closeModal } from "../../../../../../../Actions/Client/ModalActions"
import { useAsyncCommand } from "../../../../../../../Hooks/useAsyncCommand"
import { KeysModalRow } from "./KeysModalRow"

interface KeysModalProps {}

interface StateProps {
    apiKeys: string[]
}

interface DispatchProps {
    deleteKey: (key: string) => Promise<void>
    createKey: () => Promise<void>
    close: () => void
}

export type Props = KeysModalProps & StateProps & DispatchProps

export const KeysModalIsolated = ({
    apiKeys,
    createKey,
    deleteKey,
    close
}: Props) => {
    const { isProcessing, perform } = useAsyncCommand(createKey)

    const keyList =
        apiKeys && apiKeys.length > 0
            ? apiKeys.map(key => {
                  const handleDeleteKey = () => deleteKey(key)

                  return (
                      <KeysModalRow
                          key={key}
                          apiKey={key}
                          onDelete={handleDeleteKey}
                      />
                  )
              })
            : null
    return (
        <ModalPanel onClose={close}>
            <Title component="h2" variant="heading2" weight="semibold">
                API Keys
            </Title>
            {keyList}
            <AddButton
                text={isProcessing ? "Adding..." : "Add API Key"}
                onClick={perform}
            />
        </ModalPanel>
    )
}

const mapStateToProps = (state: State): StateProps => {
    return {
        apiKeys: selectApiKeys(state)
    }
}

const mapDispatchToProps = (dispatch: MainThunkDispatch): DispatchProps => {
    return {
        deleteKey: (key: string) =>
            dispatch(deleteAPIKey(key)).then(() => dispatch(getAPIKeys())),
        createKey: () =>
            dispatch(createAPIKey()).then(() => dispatch(getAPIKeys())),
        close: () => dispatch(closeModal())
    }
}

export const KeysModal = connect(
    mapStateToProps,
    mapDispatchToProps
)(KeysModalIsolated)
